import {
  DeleteOutline as DeleteOutlinedIcon,
  Edit as EditIcon,
} from '@mui/icons-material';
import { type MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu } from 'src/components/menu/Menu';
import { PATHS } from 'src/constants/paths';
import { lang } from 'src/utils';

import { LayoutMenuProps } from './LayoutMenu.interface';

export const LayoutMenu = (props: LayoutMenuProps) => {
  const navigate = useNavigate();

  const onEditClick = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    navigate({
      pathname: PATHS.ASSEMBLY_LAYOUTS_EDIT(props.card.id),
    });
    props.onClose();
  };

  const onDeleteClick = async () => {
    props.onDeleteClick();
    props.onClose();
  };

  const items = [
    {
      label: lang.edit,
      onClick: onEditClick,
      leftIcon: <EditIcon />,
      disabled: false,
    },
    {
      label: lang.deleteText,
      onClick: onDeleteClick,
      leftIcon: <DeleteOutlinedIcon />,
      disabled: false,
    },
  ];

  return (
    <Menu anchorEl={props.anchorEl} items={items} onClose={props.onClose} />
  );
};
